import {
  queryIntakeForms as publicQueryIntakeForms,
  typedQueryIntakeForms as publicTypedQueryIntakeForms,
  updateIntakeFormExpirationPeriod as publicUpdateIntakeFormExpirationPeriod,
  createCustomerSubmissionLink as publicCreateCustomerSubmissionLink,
  deleteIntakeForm as publicDeleteIntakeForm,
  archiveIntakeForm as publicArchiveIntakeForm,
  unarchiveIntakeForm as publicUnarchiveIntakeForm,
} from './intake-forms-v1-intake-form-intake-forms.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  IntakeFormQuery,
  IntakeFormsQueryBuilder,
  typedQueryIntakeForms as universalTypedQueryIntakeForms,
} from './intake-forms-v1-intake-form-intake-forms.universal.js';

function customQueryIntakeForms(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryIntakeForms(httpClient)(),
    typedQueryFunction: (query: IntakeFormQuery) =>
      publicTypedQueryIntakeForms(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): IntakeFormsQueryBuilder;
  function overloadedQuery(
    query: IntakeFormQuery
  ): ReturnType<typeof universalTypedQueryIntakeForms>;
  function overloadedQuery(query?: IntakeFormQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const updateIntakeFormExpirationPeriod: MaybeContext<
  BuildRESTFunction<typeof publicUpdateIntakeFormExpirationPeriod> &
    typeof publicUpdateIntakeFormExpirationPeriod
> = /*#__PURE__*/ createRESTModule(publicUpdateIntakeFormExpirationPeriod);
export const createCustomerSubmissionLink: MaybeContext<
  BuildRESTFunction<typeof publicCreateCustomerSubmissionLink> &
    typeof publicCreateCustomerSubmissionLink
> = /*#__PURE__*/ createRESTModule(publicCreateCustomerSubmissionLink);
export const deleteIntakeForm: MaybeContext<
  BuildRESTFunction<typeof publicDeleteIntakeForm> &
    typeof publicDeleteIntakeForm
> = /*#__PURE__*/ createRESTModule(publicDeleteIntakeForm);
export const archiveIntakeForm: MaybeContext<
  BuildRESTFunction<typeof publicArchiveIntakeForm> &
    typeof publicArchiveIntakeForm
> = /*#__PURE__*/ createRESTModule(publicArchiveIntakeForm);
export const unarchiveIntakeForm: MaybeContext<
  BuildRESTFunction<typeof publicUnarchiveIntakeForm> &
    typeof publicUnarchiveIntakeForm
> = /*#__PURE__*/ createRESTModule(publicUnarchiveIntakeForm);
export const queryIntakeForms: MaybeContext<
  BuildRESTFunction<typeof customQueryIntakeForms> &
    typeof customQueryIntakeForms
> = /*#__PURE__*/ createRESTModule(customQueryIntakeForms);

export {
  ApprovalMode,
  SortOrder,
} from './intake-forms-v1-intake-form-intake-forms.universal.js';
export {
  IntakeForm,
  PendingTriggerField,
  QueryIntakeFormsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryIntakeFormsResponse,
  CursorPagingMetadata,
  Cursors,
  UpdateIntakeFormExpirationPeriodRequest,
  UpdateIntakeFormExpirationPeriodResponse,
  UpdateIntakeFormSettingsRequest,
  UpdateIntakeFormSettingsResponse,
  CreateCustomerSubmissionLinkRequest,
  CreateCustomerSubmissionLinkResponse,
  DeleteIntakeFormRequest,
  DeleteIntakeFormResponse,
  ArchiveIntakeFormRequest,
  ArchiveIntakeFormResponse,
  UnarchiveIntakeFormRequest,
  UnarchiveIntakeFormResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  DecryptContactDetailsFromTokenRequest,
  DecryptContactDetailsFromTokenResponse,
  ContactDetails,
  IntakeFormsQueryResult,
  IntakeFormsQueryBuilder,
  IntakeFormQuerySpec,
  UpdateIntakeFormExpirationPeriodOptions,
  CreateCustomerSubmissionLinkOptions,
} from './intake-forms-v1-intake-form-intake-forms.universal.js';
export { utils } from './intake-forms-v1-intake-form-intake-forms.universal.js';
export {
  ApprovalModeWithLiterals,
  SortOrderWithLiterals,
  CreateCustomerSubmissionLinkApplicationErrors,
  CommonQueryWithEntityContext,
  IntakeFormQuery,
} from './intake-forms-v1-intake-form-intake-forms.universal.js';
